import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CoreModule } from '@app/core';
import { AppComponent } from '@app/app.component';
import { AppRoutingModule } from '@app/app-routing.module';
import { ClientResources } from '@app/client-resources.service';
import { Cookie, CookieService } from 'ng2-cookies';
import { ApiService } from '@app/shared/api.service';
import { StateService } from '@app/shared/state.service';
import { PublicLayoutComponent } from '@app/public/public-layout.component';
import { RECAPTCHA_LANGUAGE, RecaptchaModule } from 'ng-recaptcha';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxKjuaModule } from 'ngx-kjua';
import { NgIdleModule } from '@ng-idle/core';
import { UtilsService } from '@app/shared/utils.service';
import { ConstantsService } from '@app/shared/constants.service';
import { ResolveGuard } from '@app/core/resolve.guard';
import { GeorgeLibraryAppModule } from '@bcr/george-library';
import { SharedModule } from './shared';
import { LoadingModule } from '@app/shared/components/loading/loading.module';

export const getClientResources = (provider: ClientResources) => () => provider.load();

@NgModule({
  imports: [
    TranslateModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    TranslateModule.forRoot(),
    CoreModule,
    SharedModule,
    ReactiveFormsModule,
    RecaptchaModule,
    BrowserAnimationsModule,
    NgxKjuaModule,
    NgbModule,
    GeorgeLibraryAppModule,
    NgIdleModule.forRoot(),
    AppRoutingModule,
    LoadingModule,
  ],
  declarations: [AppComponent, PublicLayoutComponent],
  providers: [
    CookieService,
    StateService,
    UtilsService,
    ApiService,
    ConstantsService,
    ClientResources,
    TranslateService,
    ResolveGuard,
    {
      provide: RECAPTCHA_LANGUAGE,
      useValue: Cookie.check('language') ? Cookie.get('language') : 'ro',
    },
    { provide: APP_INITIALIZER, useFactory: getClientResources, deps: [ClientResources], multi: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
